var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('layout-sidebars-portal'),_vm._v(" "),_c('app-minimal-header'),_vm._v(" "),_c('lazy-hydrate',{attrs:{"when-visible":""}},[_c('notifications')],1),_vm._v(" "),_c('div',{attrs:{"id":"minimal"}},[_c('nuxt')],1),_vm._v(" "),_c('app-minimal-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }